import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { actions as ppcActions } from '../../reducers/ppc.reducer';
import useHasPermission from '../../helpers/hooks/useHasPermission';
import AddImage from '../common/assets/add-image/AddImage.button';
import Card from '../common/card/Card.react';
import CardHeader from '../common/card/CardHeader.react';
import CardBody from '../common/card/CardBody.react';
import Button from '../common/Button.react';
var ContactPersonImage = function ContactPersonImage(_ref) {
  var contactID = _ref._id,
    image = _ref.image,
    archived = _ref.archived;
  var _useParams = useParams(),
    app = _useParams.app;
  var dispatch = useDispatch();
  var hasPermission = useHasPermission("edit-".concat(app, "-contacts"));
  var bucket = useSelector(function (s) {
    return s.config.bucket;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Headshot"
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement("div", {
    className: "associations-logo"
  }, (image === null || image === void 0 ? void 0 : image.filename) && /*#__PURE__*/React.createElement("img", {
    src: "".concat(bucket, "/").concat(image === null || image === void 0 ? void 0 : image.filename)
  })), hasPermission && !(image !== null && image !== void 0 && image.filename) && /*#__PURE__*/React.createElement(AddImage, {
    blobType: "ppcAssociationLogo",
    disabled: archived,
    onSelect: function onSelect(asset) {
      dispatch({
        type: ppcActions.contactPersons,
        payload: {
          formData: {
            contactID: contactID,
            assetID: asset._id,
            apiID: 'add-image-button'
          },
          method: 'put',
          route: 'image'
        }
      });
    }
  }), hasPermission && (image === null || image === void 0 ? void 0 : image.filename) && /*#__PURE__*/React.createElement(Button, {
    label: "Delete",
    type: "delete",
    requireConfirmation: true,
    apiID: "del-image",
    disabled: archived,
    onClick: function onClick() {
      dispatch({
        type: ppcActions.contactPersons,
        payload: {
          formData: {
            contactID: contactID,
            apiID: 'del-image'
          },
          method: 'delete',
          route: 'image'
        }
      });
    }
  }))));
};
export default ContactPersonImage;